import React, { Component } from 'react';

import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';

import moment from 'moment';

import swal from '@sweetalert/with-react';

import API from '../../services/api';

import Loading from '../components/Loading';

// Components

import AsuForm from './form';

import AsuFilter from './filter';

import AsuList from './list';

import AsuExamContainer from './AsuExam';

// Styles

import { Wrapper, Container, Content } from './styles';

class AsuContainer extends Component {
  state = {
    modalAddAsu: false,

    isLoading: true,

    asus: [],

    employees: [],

    employeeUuid: null,

    asu: null,

    isLoadingAsu: false,
  };

  async componentDidMount() {
    const { match } = this.props;
    this.mount(match.params.uuid);
  }

  mount(uuid) {
    if (uuid) {
      this.getAsu(uuid);
    }

    this.getEmployees();
    this.getAsus();
  }

  componentWillReceiveProps(nextProps) {
    const { uuid } = nextProps.match.params;

    this.mount(uuid);
  }

  getEmployees = async () => {
    const res = await API.get(`employees/list/null/null/null/null`);

    this.setState({
      employees: res.data,

      isLoading: false,
    });
  };

  getAsus = async values => {
    this.setState({
      isLoading: true,
      employeeUuid: values && values.employee ? values.employee.uuid : null,
    });

    const { employeeUuid } = this.state;

    const res = await API.get(`asus/list/${employeeUuid || null}`);

    this.setState({
      asus: res.data,

      isLoading: false,
    });
  };

  async getAsu(uuid) {
    this.setState({
      isLoadingAsu: true,

      modalAddAsu: true,
    });

    await API.get(`asus/${uuid}`).then(res => {
      const asu = res.data[0];

      this.setState({
        asu,

        isLoadingAsu: false,
      });
    });
  }

  handleAsuDelete = async uuid => {
    const confirmDelete = await swal({
      dangerMode: true,

      text: 'Confirma a exclusão de Asu?',

      buttons: {
        cancel: 'Não',

        confirm: 'Sim',
      },
    });

    if (confirmDelete) {
      await API.delete(`asus/${uuid}`).then(() => {
        this.getAsus();

        this.setState({
          asu: null,

          modalAddAsu: false,
        });
      });
    }
  };

  handleAsuCreation = async values => {
    try {
      const { company, execution_at, employee } = values;

      await API.post(
        'asus',
        {
          company,
          execution_at: moment.utc(execution_at).format('YYYY-MM-DD'),
          employeeUuid: employee.uuid,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      ).catch(error => {
        throw error;
      });

      this.getAsus();

      this.setState({ modalAddAsu: false });
    } catch (err) {
      alert(err);
    }
  };

  handleAsuUpdate = async values => {
    const { asu } = this.state;

    try {
      const { company, execution_at, employee } = values;

      await API.put(
        `asus/${asu.uuid}`,
        {
          company,
          execution_at: moment.utc(execution_at).format('YYYY-MM-DD'),
          employeeUuid: employee.uuid,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      ).catch(error => {
        throw error;
      });

      this.getAsus();

      this.setState({ modalAddAsu: false, asu: null });
    } catch (err) {
      alert(err);
    }
  };

  render() {
    const {
      modalAddAsu,

      isLoadingAsu,

      asus,

      isLoading,

      asu,

      employees,
    } = this.state;

    const useruuid = localStorage.getItem('USER_UUID');

    return (
      <Wrapper>
        {(useruuid === 'bfa5aa85-a3a0-4e1c-a3c2-769bfe92aace' ||
          useruuid === '757b3456-08c1-45fc-9b66-75df65251611' ||
          useruuid === 'bdbafd39-5bc4-4ef1-b637-1df80d16bb0a' ||
          useruuid === 'b9cf4ca4-8935-44bb-a373-bd118776a325') && (
          <Container>
            <header>
              <h1>ASUS</h1>

              <Link
                to="/asus"
                onClick={() =>
                  this.setState({
                    modalAddAsu: !modalAddAsu,

                    asu: null,
                  })
                }
              >
                {!modalAddAsu ? 'ADICIONAR' : 'LISTA'}
              </Link>
            </header>

            <Content>
              {modalAddAsu ? (
                <>
                  {!isLoadingAsu ? (
                    <>
                      <AsuForm
                        onAsuCreation={this.handleAsuCreation}
                        onAsuUpdate={this.handleAsuUpdate}
                        isLoadingAsu={isLoadingAsu}
                        onAsuDelete={this.handleAsuDelete}
                        employees={employees}
                        asu={asu}
                      />

                      {asu && <AsuExamContainer asu={asu} />}
                    </>
                  ) : (
                    <Loading />
                  )}
                </>
              ) : (
                <>
                  <AsuFilter onList={this.getAsus} employees={employees} />

                  <AsuList
                    isLoading={isLoading}
                    ooAsuGet={this.getAsu}
                    asus={asus}
                  />
                </>
              )}
            </Content>
          </Container>
        )}
      </Wrapper>
    );
  }
}

AsuContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      uuid: PropTypes.string,
    }),
  }).isRequired,
};

export default AsuContainer;
